import type { WebhookBlock } from '@/api/types'
import { WebhookBlocks } from './WebhookBlocks'
import styles from './RoomContent.module.css'

export type WidgetBlock = WebhookBlock
  | { type: 'metric'; label: string; value: string; status: 'neutral' | 'good' | 'warning' | 'critical' }
  | { type: 'chart'; label: string; unit: string; points: { label: string; value: number }[] }

export function WidgetBlocks({ blocks }: { blocks: WidgetBlock[] }) {
  return <>{blocks.map((block, index) => {
    if (block.type === 'metric') return <div key={index} className={styles.metric}>
      <span>{block.label}</span><strong>{block.value}</strong><small>{block.status}</small>
    </div>
    if (block.type === 'chart') {
      const values = block.points.map(point => point.value)
      const min = Math.min(...values), max = Math.max(...values)
      const points = values.map((value, i) => `${10 + i * 580 / Math.max(1, values.length - 1)},${110 - (value - min) * 100 / (max - min || 1)}`).join(' ')
      return <figure key={index} className={styles.chart}>
        <figcaption>{block.label}{block.unit ? ` (${block.unit})` : ''}</figcaption>
        <svg viewBox="0 0 600 120" role="img" aria-label={`${block.label}: ${values.at(-1) ?? 0} ${block.unit}`}><polyline points={points} fill="none" stroke="currentColor" strokeWidth="3" /></svg>
        <details><summary>View values</summary><table><thead><tr><th>Time / label</th><th>Value {block.unit}</th></tr></thead><tbody>{block.points.map((point, i) => <tr key={i}><td>{point.label}</td><td>{point.value}</td></tr>)}</tbody></table></details>
      </figure>
    }
    return <WebhookBlocks key={index} blocks={[block]} keyPrefix={`widget-${index}`} />
  })}</>
}
